export default __webpack_public_path__ + "static/media/DropDownLine.99574818.svg";